/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Constants from 'galax/client/geometry/constants';

import * as Hex from 'shared/geo/hex';


export default class
{
  constructor (zoom)
  {
    this.zoom = zoom;
    this.constants = new Constants();

    this.pointsExternal = Hex.getPoints(this.getExternalWidth(), this.getExternalHeight());
    this.pointsInternal = Hex.getPoints(this.getInternalWidth(), this.getInternalHeight());

    this.pointsExternalInternal = Hex.getIntersectionPoints(this.pointsExternal, this.pointsInternal);
    this.pointsInternalExternal = Hex.getIntersectionPoints(this.pointsInternal, this.pointsExternal);
  }


  getExternalSize (ratio = 1)
  {
    return this.constants.getExternalWidth(this.zoom) / Math.sqrt(3) * ratio;
  }


  getExternalWidth (ratio = 1)
  {
    return Math.sqrt(3) * this.getExternalSize(ratio) * this.getStretchX();
  }


  getExternalHeight (ratio = 1)
  {
    return 2 * this.getExternalSize(ratio) * this.getStretchY();
  }


  getInternalSize (ratio = 1)
  {
    return this.constants.getInternalWidth(this.zoom) / Math.sqrt(3) * ratio;
  }


  getInternalWidth (ratio = 1)
  {
    return Math.sqrt(3) * this.getInternalSize(ratio) * this.getStretchX();
  }


  getInternalHeight (ratio = 1)
  {
    return 2 * this.getInternalSize(ratio) * this.getStretchY();
  }


  getExternalToInternalDistance ()
  {
    return this.getExternalSize() - this.getInternalSize();
  }


  getEntitySize ()
  {
    return this.constants.getEntitySize(this.zoom);
  }


  getUserBorderWidth ()
  {
    return this.constants.getUserBorderWidth(this.zoom);
  }


  getSectorBorderWidth ()
  {
    return this.constants.getSectorBorderWidth(this.zoom);
  }


  getZoneBorderWidth ()
  {
    return this.constants.getZoneBorderWidth(this.zoom);
  }


  getDockBorderWidth ()
  {
    return this.constants.getDockBorderWidth(this.zoom);
  }


  // TODO maybe should have overrides for the widths of 1px and 2px lines here too?


  getHorizontalDistance ()
  {
    return this.getExternalWidth();
  }


  getVerticalDistance ()
  {
    return 3/4 * this.getExternalHeight();
  }


  getStretchX ()
  {
    return 1;
  }


  getStretchY ()
  {
    return 1;
  }


  getExternalPoints ()
  {
    return this.pointsExternal;
  }


  getInternalPoints ()
  {
    return this.pointsInternal;
  }


  getZonePoints (location, neighbors)
  {
    let points = [];

    for (let i = 0; i < Hex.getPointCount(); ++i)
    {
      const borders = location.getObject().getBorders();

      let prevInternal = borders.isExternalBorder(neighbors[Hex.getPointIndex(i - 1)]);
      let nextInternal = borders.isExternalBorder(neighbors[Hex.getPointIndex(i)]);

      if (prevInternal && nextInternal)
      {
        points.push(this.pointsInternal[i]);
      }

      else if (prevInternal && !nextInternal)
      {
        points.push(this.pointsInternalExternal[i]);
      }

      else if (!prevInternal && nextInternal)
      {
        points.push(this.pointsExternalInternal[i]);
      }

      else if (!prevInternal && !nextInternal)
      {
        points.push(this.pointsExternal[i]);
      }
    }

    return points;
  }


  getVerticalBorderSize ()
  {
    return this.getExternalSize();
  }


  getDiagonalBorderSize ()
  {
    const width = this.getExternalWidth();
    const height = this.getExternalHeight();

    return Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 4, 2));
  }


  isSectorVisible ()
  {
    return this.getExternalWidth() >= 32;
  }


  isEntityVisible ()
  {
    return this.getExternalWidth() >= 48;
  }


  isZoneVisible ()
  {
    return this.getExternalWidth() >= 60;
  }


  equals (rhs)
  {
    return this.zoom === rhs.zoom;
  }


  less (rhs)
  {
    return this.zoom < rhs.zoom;
  }


};
